/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import $ from 'jquery';

import reportPageLoaded from 'legacy/_general/trace_log/trace_log';
import {downloadImportTemplate} from '@/pages/import/download';
import {getQueryParams, setQueryParams} from '@/utils';

import {
  syncExternalRequest,
  watchObject,
  resendSurvey,
} from '@/utils/crudActions';

import {buildSyncResultMessage} from './listing_utils';

import 'url-search-params-polyfill';
// TODO: doc y
import 'core-js';
import 'regenerator-runtime/runtime';

const parseId = id => {
  const idNumber = parseInt(id, 10);

  if (isNaN(idNumber)) {
    return id;
  } else {
    return idNumber;
  }
};

function post(path, params, method='post') {
  // The rest of this code assumes you are not using a library.
  // It can be made less wordy if you use one.
  const form = document.createElement('form');
  form.method = method;
  form.action = path;

  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      const hiddenField = document.createElement('input');
      hiddenField.type = 'hidden';
      hiddenField.name = key;
      hiddenField.value = params[key];

      form.appendChild(hiddenField);
    }
  }

  document.body.appendChild(form);
  form.submit();
}

const errorToMessage = (msg, error) => {
  if (
    error &&
    error.response &&
    error.response.data &&
    error.response.data.message
  ) {
    msg += ' ' + error.response.data.message;
  }

  return msg;
};

const isObjectPageModalOpen = () => {
  return !GGRC.zenModal || GGRC.zenModal.visible &&
    GGRC.zenModal.modals[0].type.includes('ObjectInfo');
};

const listingHandlers = evTarget => {
  if ($(evTarget).hasClass('listing-handlers-init')) {
    return;
  }
  $(evTarget).addClass('listing-handlers-init');

  // allow clicking inside a dropdown
  $(evTarget).on('click',
    '.header-filter .dropdown-menu, #wrench_menu .dropdown-menu', ev => {
      ev.stopPropagation();
    });

  // wrench menu
  $(evTarget).on('click', '.save-columns', ev => {
    const $target = $(ev.currentTarget);
    const fields = $target.closest('.dropdown-menu')
      .find('.column-checkbox:checked').map(function (index, el) {
        return el.value;
      }).get().join();
    let prefix = $target.data('fields-prefix');
    const magnifiedPath = $target.data('magnified-path');
    if (prefix.indexOf('?') < 0) {
      prefix += '?';
    } else {
      prefix += '&';
    }
    let magnifiedPrefix = '';
    if (magnifiedPath !== '') {
      magnifiedPrefix = magnifiedPath + '.';
    }

    const newUrl = prefix + magnifiedPrefix + 'fields=' + fields;
    if ($('body').hasClass('modal-open') &&
        $target.hasClass('js-persist-modal')) {
      $target.trigger('reload', newUrl);
    } else {
      window.location = newUrl;
    }
  });

  $(evTarget).on('click', '.object-listing-table .js-show-mapped',
    function (ev) {
      const iconToggle = $(this);
      const row = iconToggle.closest('tr');
      const width = row.children('td').length;

      if (row.hasClass('shown')) {
        row.next().remove();
        row.removeClass('shown');
      } else {
        const mappedTd = $(`<td colspan="${width}"
                            class="child-loading">Loading...</td>`);

        const cycle = row.parents('.child-row').length % 2 ?
          'child-even' : 'child-odd';

        const newRow = $('<tr/>', {
          class: 'child-row ' + cycle,
        });
        newRow.append(mappedTd);
        newRow.insertAfter(row);
        row.addClass('shown');

        const url = iconToggle.data('url');
        mappedTd.load(url).removeClass('child-loading');
      }
    }
  );

  $(evTarget).on('click', '.object-listing-table .js-reload-mapped',
    function (ev) {
      const $this = $(this);
      const url = $this.data('url');
      const td = $this.closest('td');
      td.html('Loading...');
      td.load(url);
    }
  );

  // Change datepicker mode with dropdown
  $(evTarget).on('change', '.js-change-datepicker-mode', function (event) {
    const flatpickrInstance = $(this)
      .closest('form')
      .find('#filter-value')[0]
      ._flatpickr;
    const selectedOperator = event.currentTarget.value;
    const newMode = selectedOperator === 'd>,d<' ? 'range' : 'single';

    flatpickrInstance.set('mode', newMode);
  });

  // Focus filter input when dropdown is opened
  $(evTarget).on('click', '.header-filter .dropdown-toggle', ev => {
    const $input = $(ev.currentTarget)
      .siblings('.dropdown-menu')
      .find('input[type="text"]:not(.js-init-date-picker)');

    if ($input.length) {
      setTimeout(() => {
        $input.first().focus();
      }, 25);
    }
  });

  /* eslint-disable complexity */
  // Launch object info modal
  $(evTarget).on('click', '[data-enable-object-info-modals] .title-link',
    ev => {
      // Allow cmd/ctrl click to open in new tab
      if (ev.metaKey || ev.ctrlKey) {
        return;
      }

      // Prevent duplicate modals (context issue)
      if (isObjectPageModalOpen()) {
        return;
      }

      ev.preventDefault();
      const link = ev.currentTarget;
      const linkHrefParts = decodeURI(link.href).split('/');
      const type = linkHrefParts[5];
      const id = parseId(linkHrefParts[6]);

      // Checks if data attribute exists
      const ff = typeof $('body')
        .data('feature-flag-evidence-collection') !== 'undefined';

      if (type === 'Request' && ff) {
        GGRC.zenModal.show({
          type: 'EvidenceCollection',
          data: {
            id,
            type,
          },
          context: false,
        });
      } else {
        GGRC.zenModal.show({
          type: 'ObjectInfo',
          data: {
            id,
            type,
          },
          context: true,
        });
      }
    }
  );
  /* eslint-enable complexity */

  $(evTarget).on(
    'click',
    '[data-enable-edit-modals] .inline-edit-link:not([data-prevent-modal])',
    ev => {
      const dataset = ev.currentTarget.dataset;

      GGRC.zenModal.show({
        type: 'EditCard',
        data: {
          ids: [parseId(dataset.identifier)],
          type: dataset.objectType,
          field: dataset.attrSlug,
        },
      });
    });

  // Download import template
  $(evTarget).on('click', '.js-download-template', ev => {
    const $this = $(ev.currentTarget);
    const type = $this.data('type');
    const typeFilename = $this.data('type-filename')
      .split(' ').join('').toLowerCase();
    const filename = `import_${typeFilename}_template.csv`;
    const csrfToken = $('body').data('csrf');

    const data = [{
      object_name: type,
      fields: 'all',
    }];

    downloadImportTemplate(filename, data, csrfToken);
  });

  // Show a card for "Create a task" and "Delete" links
  $(evTarget).on('click', '.js-do-object-info-action', ev => {
    const link = ev.currentTarget;

    if (link.href) {
      ev.preventDefault();
    }

    const csrfToken = $('body').data('csrf');
    const modalConfigs = {
      DELETE: {
        type: 'OldDeleteCard',
        data: {
          axiosRequest: {
            method: 'POST',
            url: link.dataset.postUrl,
            headers: {
              'X-CSRF-Token': link.dataset.csrfToken,
            },
          },
          objectTitle: link.dataset.objectTitle,
          objectType: link.dataset.objectType,
          redirectUrl: link.dataset.redirectUrl,
        },
      },
      PREVIEW_SURVEY_EMAIL: {
        type: 'GenericCard',
        data: {
          axiosRequest: {
            method: 'POST',
            url: link.dataset.postUrl,
            headers: {
              'X-CSRF-Token': link.dataset.csrfToken,
            },
          },
          objectTitle: link.dataset.objectTitle,
          objectType: link.dataset.objectType,
          redirectUrl: link.dataset.redirectUrl,
        },
      },
      CREATE_TASK: {
        type: 'NewObject',
        data: {
          url: link.href,
          type: 'Task',
        },
      },
      CREATE_ISSUE: {
        type: 'NewObject',
        data: {
          url: link.href,
          type: 'Issue',
        },
      },
      UNLINK_JIRA_ISSUE: {
        type: 'UnlinkJiraConfirmation',
        data: link.dataset,
      },
      OPEN_JIRA_ISSUE: {
        type: 'JiraIssue',
        data: {
          id: link.dataset.id,
          csrfToken: csrfToken,
        },
      },
      CLOSE: {
        type: 'CloseCard',
        data: {
          axiosRequest: {
            method: 'POST',
            url: link.dataset.postUrl,
            headers: {
              'X-CSRF-Token': link.dataset.csrfToken,
            },
          },
          objectTitle: link.dataset.objectTitle,
          objectType: link.dataset.objectType,
          redirectUrl: link.dataset.redirectUrl,
        },
      },
    };


    if (link.dataset.action == 'PREVIEW_SURVEY_EMAIL') {
      const postParams = JSON.parse(link.dataset.postParams);
      const csrfToken = $('body').data('csrf');
      postParams['csrf_token'] = csrfToken;
      post(link.dataset.postUrl, postParams);
    } else {
      GGRC.zenModal.show(modalConfigs[link.dataset.action]);
    }
  });

  $(evTarget).on('click', '.js-watch-object-action', async ev => {
    const data = ev.currentTarget.dataset;
    const csrfToken = $('body').data('csrf');
    if (await GGRC.zenModal.confirm(data.message, data.title)) {
      try {
        await watchObject({
          csrf: csrfToken,
          postUrl: data.postUrl,
          unwatch: data.watch === 'stop',
        });
        // TODO fix for SPA
        location.reload();
      } catch (error) {
        console.error(error);
        window.GGRC.Notify({
          type: 'error',
          message: 'Oops, something went wrong.',
        });
      }
    }
  });

  $(evTarget).on('click', '.js-external-request-sync-action', async ev => {
    const data = ev.currentTarget.dataset;
    const csrfToken = $('body').data('csrf');

    try {
      const syncResponse = await syncExternalRequest(data.postUrl, csrfToken);
      const modalInfo = buildSyncResultMessage(syncResponse);
      window.GGRC.NotifyNextLoad({
        type: modalInfo.modalType,
        message: modalInfo.message,
      });
      location.reload();
    } catch (error) {
      console.error(error);
      window.GGRC.Notify({
        type: 'error',
        message: errorToMessage('Synchronization failed.', error),
      });
    }
  });

  $(window).on('load', () => {
    const params = new URLSearchParams(getQueryParams());
    if (params.has('linkJira')) {
      params.delete('linkJira');
      setQueryParams(params.toString());
      $('.js-link-jira-issues').click();
    }

    reportPageLoaded();
  });
};
export default listingHandlers;
